window.$ = window.jQuery = require('jquery');

require("jquery-validation");
require("jquery-validation-unobtrusive");

require("bootstrap-transition");
require("bootstrap-collapse");
require("bootstrap-tooltip");
require("bootstrap-modal");

var equalise = require('./_appius.equalise.js');
var scroller = require('./_appius.scroller.js');

require('./_appius.activeNavigation.js');
require('./_appius.backToTop.js');
require('./_appius.carousel.js');
require('./_appius.mobileNavDropdown.js');
require('./_appius.mobileNav.js');
require('./_appius.tabletNav.js');
require('./_appius.searchHeader.js');
require('./_appius.interactiveMap.js');
require('./_appius.search.js');
require('./_appius.scrollTo.js');
require('./_appius.publicationsFilter.js');
require('./vendor/_jquery.validate.min.js');
require('./vendor/_jquery.validate.unobtrusive.min.js');
require('./vendor/_imageMapResizer.js');
require('./_appius.faqJump.js');

$(document).ready(function () {
    $('.client-list [data-toggle="collapse"]').click(function (e) {
        if ($(window).width() >= 768) {
            e.preventDefault();
            e.stopPropagation();
        }
    });

    $('map').imageMapResize();
});